export default __webpack_public_path__ + "static/media/carousel-right.f1f59bcd.svg";